import EncounterBillingCard from './EncounterBillingCard';

export default EncounterBillingCard;
